import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { OrganizationService } from '../../../services/organization.service';

@Component({
  selector: 'app-organization-type',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './organization-type.component.html',
  styleUrls: ['./organization-type.component.scss']
})
export class OrganizationTypeComponent implements OnInit {
  organizationTypes: any[] = [];

  // IntentGroup options mirror the backend enum and provide user-friendly labels
  intentGroupOptions = [
    { id: 0, value: 'Root', label: 'Root' },
    { id: 1, value: 'SmallTalk', label: 'Small Talk' },
    { id: 2, value: 'Custom', label: 'Custom' },
    { id: 3, value: 'LocalGov', label: 'Local Government' },
    { id: 4, value: 'HigherEducation', label: 'Higher Education' },
    { id: 5, value: 'FurtherEducation', label: 'Further Education' }
  ];

  // newType holds the name and an array of selected intent group values
  newType: any = { name: '', intentGroupsArr: [] as string[] };
  loading = false;
  error: string | null = null;

  constructor(private service: OrganizationService, private router: Router) { }

  ngOnInit(): void {
    this.loadOrganizationTypes();
  }

  loadOrganizationTypes() {
    this.service.getOrganizationTypes().subscribe({
      next: (data) => this.organizationTypes = data || [],
      error: (err) => console.error('Error loading organization types', err)
    });
  }

  // Format a comma-separated intentGroups string into friendly labels
  formatIntentGroups(csv: string | null | undefined): string {
    if (!csv) return '';
    const parts = csv.split(',').map(p => p.trim()).filter(Boolean);

    return parts.map(p => {
      // If numeric (e.g., "0,3"), map using the enum id
      if (/^\d+$/.test(p)) {
        const idx = Number(p);
        const opt = this.intentGroupOptions.find(x => x.id === idx);
        return opt?.label || p;
      }
      // Otherwise map by enum name (e.g., "LocalGov")
      const opt = this.intentGroupOptions.find(x => x.value === p);
      return opt?.label || p;
    }).join(', ');
  }

  create() {
    if (!this.newType.name || this.newType.name.trim().length === 0) {
      this.error = 'Name is required';
      return;
    }
    this.error = null;
    this.loading = true;

    // Ensure unique values and convert to comma-separated string (backend expects a CSV string or null)
    const uniqueGroups = Array.from(new Set(this.newType.intentGroupsArr || []));
    const intentGroups = uniqueGroups.length ? uniqueGroups.join(',') : null;

    const body: any = {
      Name: this.newType.name,
      IntentGroups: intentGroups
    };

    this.service.createOrganizationType(body).subscribe({
      next: () => {
        this.newType = { name: '', intentGroupsArr: [] };
        this.loadOrganizationTypes();
        this.loading = false;
      },
      error: (err) => {
        console.error('Create failed', err);
        this.error = 'Failed to create organization type';
        this.loading = false;
      }
    });
  }
}
